export const WidgetView = {
    page: 'page',
    pinboard: 'pinboard',
    reportView: 'reportView',
    reportAddWidget: 'reportAddWidget',
    reportEditWidget: 'reportEditWidget',
} as const;

export type WidgetViewMode = (typeof WidgetView)[keyof typeof WidgetView];

export class WidgetViewModeUtils {
    static isReportView(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.reportView;
    }

    static isPinboardView(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.pinboard;
    }

    static isPageView(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.page;
    }

    static isReportOrPinboardView(mode: WidgetViewMode | undefined) {
        return WidgetViewModeUtils.isReportView(mode) || WidgetViewModeUtils.isPinboardView(mode);
    }

    static isReportEditWidget(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.reportEditWidget;
    }

    static isReportAddWidget(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.reportAddWidget;
    }

    static isReportAddOrEditWidget(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.reportAddWidget || mode === WidgetView.reportEditWidget;
    }

    static isPageOrReportAddOrEditWidget(mode: WidgetViewMode | undefined) {
        return WidgetViewModeUtils.isPageView(mode) || WidgetViewModeUtils.isReportAddOrEditWidget(mode);
    }

    static isInAnyReportMode(mode: WidgetViewMode | undefined) {
        return (
            mode === WidgetView.reportEditWidget ||
            mode === WidgetView.reportAddWidget ||
            mode === WidgetView.reportView
        );
    }

    static isInAnyReportViewOrAddMode(mode: WidgetViewMode | undefined) {
        return mode === WidgetView.reportAddWidget || mode === WidgetView.reportView;
    }
}
